import React from 'react';
import './About.css';
import Image from '../../assets/young.jpg';
import Resume from "../../assets/Ayush_Singh_Resume.pdf"


const About = () => {
     const downloadResume = async () => {
        window.open(Resume, '_blank');
    }

    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me </h2>

            <div className="about__container grid">
                <img src={Image} alt="" className='about__img' />

                <div className="about__data grid">
                    <div className="about__info">
                        <p className="about__description">
    Hello! I'm Ayush, a Software Developer and aspiring Data Scientist from India. I hold a B.Tech in Computer Science and Engineering from Bharat Institute of Technology.<br /><br />
    My journey into tech has been filled with continuous learning and hands-on building. I'm currently focused on enhancing my skills in data science while also expanding my portfolio with full-stack web applications. I believe in the power of teamwork, problem-solving, and creating impactful digital solutions.<br /><br />
    
  </p>
                        <button className="btn" onClick={downloadResume}>Donwload CV</button>
                    </div>

                     
                </div>
            </div>

     
        </section>
    )
}

export default About